
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Scribe": () => {
return Promise.all(/*  | __federation_expose_Scribe */ [__webpack_require__.e("787"), __webpack_require__.e("672"), __webpack_require__.e("971"), __webpack_require__.e("615")]).then(() => (() => (__webpack_require__(1532))));
},
"./ScribeSettings": () => {
return Promise.all(/*  | __federation_expose_ScribeSettings */ [__webpack_require__.e("787"), __webpack_require__.e("672"), __webpack_require__.e("650"), __webpack_require__.e("194")]).then(() => (() => (__webpack_require__(5891))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };